// Based on: https://github.com/magento-research/pwa-studio/blob/develop/packages/venia-concept/src/actions/cart/asyncActions.js
import { Util } from '@magento/peregrine'

const { BrowserPersistence } = Util

const storage = new BrowserPersistence() as Storage

export default storage
